import { Reducer } from 'redux';
import { UserActionTypes } from '../constants/actionTypes';
import { IUserProfileData, IUserProfileDataAction } from '../actions/userAction';

export type UserActions = IUserProfileDataAction;

export interface IUserProfileState {
  readonly userProfileStateData: IUserProfileData | undefined | null;
}

// Define the initial state
const initialState: IUserProfileState = {
  userProfileStateData: undefined,
};

export const userReducer: Reducer<IUserProfileState, UserActions> = (
  state = initialState,
  action: UserActions,
) => {
  switch (action.type) {
    case UserActionTypes.FETCH_USER_PROFILE_DATA:
      return {
        ...state,
        userProfileStateData: action.userProfileData,
      };
    default:
      return state;
  }
};
